<template>
 <!-- 重置密码 -->
 <div>
    <el-dialog :title="title"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="resetPasswordMark"
    width="500px"
    center>
      <div style="width:30%;margin:0 auto">
        <span>是否重置账号密码？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passWordSave">确 定</el-button>
        <el-button @click="resetPasswordMark = false">取 消</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { updatePassword } from '@/api/newCrm'
export default {
  name: 'resetPassword',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      // 重置密码
      resetPasswordMark: false,
      resetPasswordId: '',
      passWordData: '', // 密码内容
      title: ''
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    // this.getList(this.searchFrom)
    this.resetPassWordClick(this.rowData) 
    },
  methods: {
     // 重置密码
    resetPassWordClick (row) {
      this.title = '重置密码'
      this.resetPasswordMark = true
      this.resetPasswordId = row.id
    },
    // 点击重置密码保存
    passWordSave () {
      updatePassword({
        id: this.resetPasswordId
      }).then(res => {
        this.passWordData = res
        this.$alert('密码已重置为' + this.passWordData + '请妥善保管！', '系统提示')
        this.resetPasswordMark = false
        this.$emit('getList')
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    closeDialog () {
       this.$emit('destroy')
    }
  },
}
</script>

<style scoped lang='less'>

</style>
